import { Injectable } from '@angular/core';
import { AppConfigService, IDP_APPS } from '@com-delta-idp/mnx-utils';
import { Observable, ReplaySubject } from 'rxjs';
import { DashboardResponse, EndpointKeys } from '../models';

@Injectable({
  providedIn: 'root'
})
export class SessionHelperService {
  loggedIn$: Observable<boolean>;
  protected _redirect = true;

  private _loggedIn$: ReplaySubject<boolean> = new ReplaySubject<boolean>();
  protected _dashboardData$: ReplaySubject<Partial<DashboardResponse>> =
    new ReplaySubject<Partial<DashboardResponse>>();

  constructor(protected appConfig: AppConfigService) {
    this.loggedIn$ = this._loggedIn$.asObservable();
  }

  protected validateRedirect(status: boolean, loginRedirect = false) {
    if ((!status && this._redirect) || loginRedirect) {
      this.redirect();
    }
  }

  protected setResponseValues(
    response: Partial<DashboardResponse>,
    status: boolean
  ) {
    this._loggedIn$.next(status);
    this._dashboardData$.next(response);
  }

  protected redirect() {
    this.appConfig
      .getConfigValue(IDP_APPS.COMMON, EndpointKeys['LOGIN_URL'])
      .subscribe((loginUrl) => {
        const pathname = window.location.pathname;
        const search = window.location.search;
        // Add search only if present
        const fullPath = pathname + (search ? search : '');

        const url = `${
          window.location.origin
        }${loginUrl}?refreshURL=${encodeURIComponent(fullPath)}`;
        window.open(url, '_self');
      })
      .unsubscribe();
  }
}
